// @ts-nocheck
import { PageHeader } from "../components/layout/PageHeader";
import { StatCard } from "../components/StatCard";
import { useLang } from "../lib/lang";

export function Subscription() {
  const { t, lang } = useLang();
  const d = t.subscription;

  const PLANS = [
    {
      key: "Starter",
      name_en: "Starter", name_he: "מתחיל",
      price: 9,
      features_en: ["1 WhatsApp Device", "1,000 Contacts", "10,000 Messages/month", "Basic Templates", "Email Support"],
      features_he: ["מכשיר וואטסאפ 1", "1,000 אנשי קשר", "10,000 הודעות/חודש", "תבניות בסיסיות", "תמיכה באימייל"],
    },
    {
      key: "Business",
      name_en: "Business", name_he: "עסקי",
      price: 29, popular: true,
      features_en: ["5 WhatsApp Devices", "10,000 Contacts", "100,000 Messages/month", "Advanced Templates", "Chatbot (Auto Reply)", "Priority Support"],
      features_he: ["5 מכשירי וואטסאפ", "10,000 אנשי קשר", "100,000 הודעות/חודש", "תבניות מתקדמות", "צ'אטבוט (מענה אוטומטי)", "תמיכה מועדפת"],
    },
    {
      key: "Enterprise",
      name_en: "Enterprise", name_he: "ארגוני",
      price: 79,
      features_en: ["20 WhatsApp Devices", "100,000 Contacts", "1M Messages/month", "All Templates", "Chatbot + Webhooks", "API Access", "Dedicated Support"],
      features_he: ["20 מכשירי וואטסאפ", "100,000 אנשי קשר", "1M הודעות/חודש", "כל התבניות", "צ'אטבוט + Webhooks", "גישה ל-API", "תמיכה ייעודית"],
    },
  ];

  return (
    <div>
      <PageHeader title={d.title} />
      <div className="px-6 pb-6 space-y-6">
        <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef] p-5">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-[#8898aa] mb-1">{d.currentPlan}</p>
              <h3 className="text-2xl font-bold text-[#32325d]">{d.businessPlan}</h3>
              <p className="text-sm text-[#8898aa] mt-1">{d.renewsOn}</p>
            </div>
            <div className="text-end">
              <p className="text-3xl font-bold text-[#1171ef]">$29<span className="text-sm font-normal text-[#8898aa]">/mo</span></p>
              <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-[#d4edda] text-[#155724]">{d.active}</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <StatCard label={d.devicesUsed} value="2 / 5" iconClass="fas fa-mobile-alt" gradient="primary" />
          <StatCard label={d.contactsUsed} value="4 / 10,000" iconClass="fas fa-users" gradient="info" />
          <StatCard label={d.messagesMonth} value="120 / 100,000" iconClass="fas fa-paper-plane" gradient="success" />
        </div>

        <div>
          <h4 className="text-sm font-semibold text-[#32325d] mb-4">{d.upgradeTitle}</h4>
          <div className="grid grid-cols-3 gap-4">
            {PLANS.map(plan => (
              <div key={plan.key} className={`bg-white rounded-xl border-2 p-5 relative ${plan.popular ? "border-[#1171ef] shadow-lg" : "border-[#e9ecef] shadow-sm"}`}>
                {plan.popular && (
                  <div className="absolute -top-3 start-1/2 -translate-x-1/2">
                    <span className="gradient-primary text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-sm">{d.popular}</span>
                  </div>
                )}
                <h5 className="font-bold text-[#32325d] text-lg">{lang === "he" ? plan.name_he : plan.name_en}</h5>
                <p className="text-3xl font-bold text-[#1171ef] mt-2">${plan.price}<span className="text-sm font-normal text-[#8898aa]">/mo</span></p>
                <ul className="mt-4 space-y-2">
                  {(lang === "he" ? plan.features_he : plan.features_en).map((f, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-[#525f7f]">
                      <i className="fas fa-check text-[#2dce89] text-xs shrink-0" />{f}
                    </li>
                  ))}
                </ul>
                <button className={`w-full mt-4 py-2 rounded-lg text-sm font-medium transition-colors ${plan.popular ? "gradient-primary text-white shadow-sm hover:opacity-90" : "border border-[#1171ef] text-[#1171ef] hover:bg-[#eef0fd]"}`}>
                  {plan.popular ? d.currentPlanBtn : d.switchPlan}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
